const defaultState = {
  textColor: '',
  backgroundColor: '',
};
export const button = (state = defaultState, action) => {
  const { type, payload } = action;
  switch (type) {
    default:
      return state;
  }
};
